import { router } from "../router/router.js";
import { contextStore } from "../auth/context-store.js";
import { platform } from "../../app/browser-platform.js";

export default class ManagementHubPage extends HTMLElement {
  public connectedCallback(): void {
    this.render();
  }

  private render(): void {
    this.innerHTML = `
      <div style="display: flex; flex-direction: column; height: 100%; gap: 24px; background: var(--color-bg-primary); padding: 28px; overflow-y: auto;">
        <header style="border-bottom: 1px solid var(--color-graphite-200); padding-bottom: 16px;">
          <h1 style="color: var(--color-text-muted); font-size: 1.75rem; font-weight: 700; margin: 0;">Módulo de Gestão Operacional</h1>
          <p style="color: var(--color-text-secondary); font-size: 0.9375rem; margin-top: 6px;">Gestão centralizada de clientes, unidades industriais, ordens de serviço (OS) e frentes operacionais.</p>
        </header>

        <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); gap: 20px;">
          <!-- Clientes -->
          <div class="admin-card" data-path="/management/clients" style="background: var(--color-surface-primary); border: 1px solid var(--color-graphite-200); border-radius: 10px; padding: 20px; cursor: pointer; transition: all 0.2s; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
            <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 12px;">
              <div style="background: var(--color-surface-secondary); color: var(--color-ink); width: 42px; height: 42px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 1.25rem; font-weight: 700;"><i data-lucide="building-2"></i></div>
              <div>
                <h3 style="margin: 0; font-size: 1.125rem; font-weight: 600; color: var(--color-text-muted);">Clientes & Unidades</h3>
                <span style="font-size: 0.75rem; color: var(--color-text-secondary);">Multitenant / Plantas Industriais</span>
              </div>
            </div>
            <p style="color: var(--color-text-secondary); font-size: 0.875rem; margin: 0; line-height: 1.4;">Cadastro de empresas contratantes, segregação de dados por tenant e unidades operacionais.</p>
          </div>

          <!-- Projetos e Unidades/áreas -->
          <div class="admin-card" data-path="/management/projects" style="background: var(--color-surface-primary); border: 1px solid var(--color-graphite-200); border-radius: 10px; padding: 20px; cursor: pointer; transition: all 0.2s; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
            <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 12px;">
              <div style="background: var(--color-surface-secondary); color: var(--ia-primary); width: 42px; height: 42px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 1.25rem; font-weight: 700;"><i data-lucide="folder-open"></i></div>
              <div>
                <h3 style="margin: 0; font-size: 1.125rem; font-weight: 600; color: var(--color-text-muted);">Projetos & Unidades/áreas</h3>
                <span style="font-size: 0.75rem; color: var(--color-text-secondary);">Hierarquia: Projeto &rarr; Unidade/área</span>
              </div>
            </div>
            <p style="color: var(--color-text-secondary); font-size: 0.875rem; margin: 0; line-height: 1.4;">Cadastro e administração de projetos e suas respectivas unidades/áreas vinculadas ao cliente ativo.</p>
          </div>

          <!-- Ordens de Serviço (OS) & Sub-OS -->
          <div class="admin-card" data-path="/management/os" style="background: var(--color-surface-primary); border: 1px solid var(--color-graphite-200); border-radius: 10px; padding: 20px; cursor: pointer; transition: all 0.2s; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
            <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 12px;">
              <div style="background: var(--status-success-bg); color: var(--status-success-text); width: 42px; height: 42px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 1.25rem; font-weight: 700;"><i data-lucide="clipboard-list"></i></div>
              <div>
                <h3 style="margin: 0; font-size: 1.125rem; font-weight: 600; color: var(--color-text-muted);">Ordem de Serviço (OS)</h3>
                <span style="font-size: 0.75rem; color: var(--color-text-secondary);">OS Mestres & Sub-OS</span>
              </div>
            </div>
            <p style="color: var(--color-text-secondary); font-size: 0.875rem; margin: 0; line-height: 1.4;">Gestão de contratos e ordens de serviço para rastreamento de campanhas de inspeção.</p>
          </div>

          <!-- Frentes de Serviço -->
          <div class="admin-card" data-path="/management/fronts" style="background: var(--color-surface-primary); border: 1px solid var(--color-graphite-200); border-radius: 10px; padding: 20px; cursor: pointer; transition: all 0.2s; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
            <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 12px;">
              <div style="background: rgba(168,85,247,0.15); color: var(--ia-info-fg, #d8b4fe); width: 42px; height: 42px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 1.25rem; font-weight: 700;"><i data-lucide="cone"></i></div>
              <div>
                <h3 style="margin: 0; font-size: 1.125rem; font-weight: 600; color: var(--color-text-muted);">Frentes de Serviço</h3>
                <span style="font-size: 0.75rem; color: var(--color-text-secondary);">Equipes de Campo</span>
              </div>
            </div>
            <p style="color: var(--color-text-secondary); font-size: 0.875rem; margin: 0; line-height: 1.4;">Configuração de frentes operacionais de trabalho associadas a ordens de serviço específicas.</p>
          </div>

          <!-- RDO -->
          <div class="admin-card" data-path="/management/rdo" style="background: var(--color-surface-primary); border: 1px solid var(--color-graphite-200); border-radius: 10px; padding: 20px; cursor: pointer; transition: all 0.2s; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
            <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 12px;">
              <div style="background: var(--status-info-bg); color: var(--ia-primary); width: 42px; height: 42px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 1.25rem; font-weight: 700;"><i data-lucide="file-text"></i></div>
              <div>
                <h3 style="margin: 0; font-size: 1.125rem; font-weight: 600; color: var(--color-text-muted);">Relatório Diário (RDO)</h3>
                <span style="font-size: 0.75rem; color: var(--color-text-secondary);">Apontamentos Operacionais</span>
              </div>
            </div>
            <p style="color: var(--color-text-secondary); font-size: 0.875rem; margin: 0; line-height: 1.4;">Lançamento e registro das atividades diárias executadas pela frente de serviço.</p>
          </div>

          <!-- Reset Controlado & Backup (Admin) -->
          <div class="admin-card reset-card" id="btn-open-reset-modal" style="background: rgba(244,63,94,0.1); border: 1px solid rgba(244,63,94,0.3); border-radius: 10px; padding: 20px; cursor: pointer; transition: all 0.2s; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
            <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 12px;">
              <div style="background: rgba(244,63,94,0.2); color: var(--ia-danger-fg, #fda4af); width: 42px; height: 42px; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-size: 1.25rem; font-weight: 700;"><i data-lucide="shield-alert"></i></div>
              <div>
                <h3 style="margin: 0; font-size: 1.125rem; font-weight: 600; color: var(--ia-danger-fg, #FDA4AF);">Reset Controlado da Base</h3>
                <span style="font-size: 0.75rem; color: var(--ia-danger-fg, #FB7185); font-weight: 600;">Snapshot Prévio & Limpeza Segura</span>
              </div>
            </div>
            <p style="color: var(--color-text-secondary); font-size: 0.875rem; margin: 0; line-height: 1.4;">Limpeza de Clientes, Projetos, OS e Usuários com backup completo automático e preservação do Administrador e RBAC.</p>
          </div>

        </div>

        <!-- Modal de Reset Controlado -->
        <div id="reset-modal-container"></div>
      </div>
    `;

    this.querySelectorAll(".admin-card:not(.reset-card)").forEach(card => {
      card.addEventListener("click", () => {
        const path = card.getAttribute("data-path");
        if (path) router.navigate(path);
      });
      card.addEventListener("mouseenter", () => {
        (card as HTMLElement).style.borderColor = "var(--color-ink)";
        (card as HTMLElement).style.transform = "translateY(-2px)";
      });
      card.addEventListener("mouseleave", () => {
        (card as HTMLElement).style.borderColor = "var(--color-graphite-200)";
        (card as HTMLElement).style.transform = "translateY(0)";
      });
    });

    const resetBtn = this.querySelector("#btn-open-reset-modal");
    if (resetBtn) {
      resetBtn.addEventListener("click", () => this.openResetModal());
    }
  }

  private openResetModal(): void {
    const container = this.querySelector("#reset-modal-container");
    if (!container) return;

    // Dynamically import systemResetService
    import("../../app/system-reset-service.js").then(({ systemResetService }) => {
      const counts = systemResetService.getEntityCounts();
      const backups = systemResetService.listBackups();

      container.innerHTML = `
        <div style="position: fixed; inset: 0; background: rgba(0,0,0,0.6); display: flex; align-items: center; justify-content: center; z-index: 10000; backdrop-filter: blur(2px);">
          <div style="background: var(--color-surface-primary); border-radius: 12px; width: 100%; max-width: 580px; padding: 24px; box-shadow: 0 20px 25px -5px rgba(0,0,0,0.2); max-height: 90vh; overflow-y: auto;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; border-bottom: 1px solid var(--color-graphite-200); padding-bottom: 12px;">
              <div>
                <h2 style="font-size: 1.25rem; font-weight: 700; color: var(--color-text-muted); margin: 0;">Reset Controlado de Dados Operacionais</h2>
                <p style="margin: 4px 0 0 0; font-size: 0.8125rem; color: var(--color-text-secondary);">Limpeza de registros operacionais com salvaguardas estritas e backup automático.</p>
              </div>
              <button id="btn-close-reset-modal" style="background: none; border: none; font-size: 1.25rem; cursor: pointer; color: var(--color-text-secondary);">✕</button>
            </div>

            <!-- Painel de Contagens Atuais -->
            <div style="background: var(--color-surface-secondary); border: 1px solid var(--color-graphite-200); border-radius: 8px; padding: 14px; margin-bottom: 16px;">
              <div style="font-size: 0.8125rem; font-weight: 700; color: var(--color-text-muted); margin-bottom: 10px; text-transform: uppercase; letter-spacing: 0.05em;">
                Status Atual da Base de Dados:
              </div>
              <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; font-size: 0.8125rem;">
                <div style="background: var(--color-surface-primary); padding: 8px; border-radius: 6px; border: 1px solid var(--color-graphite-200);">
                  <span style="color: var(--color-text-secondary); display: block;">Clientes:</span>
                  <strong style="font-size: 1.1rem; color: ${counts.clients > 0 ? '#b91c1c' : '#15803d'};">${counts.clients}</strong>
                </div>
                <div style="background: var(--color-surface-primary); padding: 8px; border-radius: 6px; border: 1px solid var(--color-graphite-200);">
                  <span style="color: var(--color-text-secondary); display: block;">Projetos:</span>
                  <strong style="font-size: 1.1rem; color: ${counts.projects > 0 ? '#b91c1c' : '#15803d'};">${counts.projects}</strong>
                </div>
                <div style="background: var(--color-surface-primary); padding: 8px; border-radius: 6px; border: 1px solid var(--color-graphite-200);">
                  <span style="color: var(--color-text-secondary); display: block;">Ordens de Serviço (OS):</span>
                  <strong style="font-size: 1.1rem; color: ${counts.workOrders > 0 ? '#b91c1c' : '#15803d'};">${counts.workOrders}</strong>
                </div>
                <div style="background: var(--color-surface-primary); padding: 8px; border-radius: 6px; border: 1px solid var(--color-graphite-200);">
                  <span style="color: var(--color-text-secondary); display: block;">Sub-OS:</span>
                  <strong style="font-size: 1.1rem; color: ${counts.subWorkOrders > 0 ? '#b91c1c' : '#15803d'};">${counts.subWorkOrders}</strong>
                </div>
                <div style="background: var(--color-surface-primary); padding: 8px; border-radius: 6px; border: 1px solid var(--color-graphite-200);">
                  <span style="color: var(--color-text-secondary); display: block;">Usuários:</span>
                  <strong style="font-size: 1.1rem; color: var(--color-text-muted);">${counts.users}</strong>
                  <span style="font-size: 0.7rem; color: #15803d; display: block;">(${counts.admins} Admin Preservado)</span>
                </div>
                <div style="background: var(--color-surface-primary); padding: 8px; border-radius: 6px; border: 1px solid var(--color-graphite-200);">
                  <span style="color: var(--color-text-secondary); display: block;">Profissionais:</span>
                  <strong style="font-size: 1.1rem; color: #15803d;">${counts.professionals} (Mantidos)</strong>
                </div>
              </div>
            </div>

            <!-- Avisos e Garantias -->
            <div style="background: rgba(245,158,11,0.1); border: 1px solid rgba(245,158,11,0.3); border-radius: 8px; padding: 12px; margin-bottom: 16px; font-size: 0.8125rem; color: var(--ia-warning-fg, #fcd34d); line-height: 1.5;">
              <strong>Garantias de Integridade:</strong>
              <ul style="margin: 6px 0 0 0; padding-left: 18px;">
                <li>Snapshot completo automático salvo com data/hora antes da limpeza.</li>
                <li>O Administrador Ativo (admin@inspect.ai) não será apagado.</li>
                <li>RBAC, Perfis, Permissões, Templates e Tipos de Ativo são 100% preservados.</li>
                <li>Rollback transacional automático caso qualquer etapa falhe.</li>
              </ul>
            </div>

            <div id="reset-result-message" style="display: none; margin-bottom: 16px; padding: 12px; border-radius: 6px; font-size: 0.85rem;"></div>

            <!-- Ações -->
            <div style="display: flex; justify-content: flex-end; gap: 12px; align-items: center; border-top: 1px solid var(--color-graphite-200); padding-top: 16px;">
              <button id="btn-cancel-reset" style="background: var(--color-surface-secondary); border: 1px solid var(--color-graphite-300); border-radius: 6px; padding: 9px 18px; font-size: 0.875rem; font-weight: 600; cursor: pointer; color: var(--color-text-muted);">Fechar</button>
              <button id="btn-confirm-execute-reset" style="background: var(--status-danger-solid); border: none; border-radius: 6px; padding: 9px 20px; font-size: 0.875rem; font-weight: 600; color: var(--color-text-primary); cursor: pointer; display: flex; align-items: center; gap: 6px;">
                Executar Limpeza & Reset Controlado
              </button>
            </div>
          </div>
        </div>
      `;

      container.querySelector("#btn-close-reset-modal")?.addEventListener("click", () => {
        container.innerHTML = "";
      });
      container.querySelector("#btn-cancel-reset")?.addEventListener("click", () => {
        container.innerHTML = "";
      });

      const confirmBtn = container.querySelector("#btn-confirm-execute-reset");
      confirmBtn?.addEventListener("click", () => {
        if (!confirm("CONFIRMAÇÃO CRÍTICA:\n\nDeseja realizar o Reset Controlado agora?\n\n- Um Snapshot completo da base será gerado imediatamente.\n- Sub-OS, OS, Projetos e Clientes serão esvaziados.\n- Os usuários operacionais serão limpos, preservando o Administrador ativo.")) {
          return;
        }

        const res = systemResetService.executeControlledReset({ executedBy: 'Administrador (Manual no Hub)' });
        const msgEl = container.querySelector("#reset-result-message") as HTMLElement;
        if (msgEl) {
          msgEl.style.display = "block";
          if (res.success) {
            msgEl.style.background = "var(--status-success-bg)";
            msgEl.style.border = "1px solid var(--status-success-border)";
            msgEl.style.color = "var(--status-success-text)";
            msgEl.innerHTML = `
              <strong>✓ Limpeza Concluída com Sucesso!</strong><br>
              Backup criado: <code>${res.backupKey}</code><br>
              Clientes restantes: ${res.after.clients} | Projetos: ${res.after.projects} | OS: ${res.after.workOrders} | Sub-OS: ${res.after.subWorkOrders} | Usuários: ${res.after.users} (Admin Ativo)
            `;
            setTimeout(() => {
              this.render();
            }, 1500);
          } else {
            msgEl.style.background = "var(--status-danger-bg)";
            msgEl.style.border = "1px solid var(--status-danger-border)";
            msgEl.style.color = "var(--status-danger-text)";
            msgEl.innerHTML = `<strong>Falha na operação:</strong> ${res.error}`;
          }
        }
      });
    });
  }
}

if (!customElements.get("app-management-hub-page")) {
  customElements.define("app-management-hub-page", ManagementHubPage);
}



